
<template>
  	<div class="animated fadeIn">
		<b-row>
		    <b-col cols="12">
				<b-card header-tag="header" footer-tag="footer">
			        <div slot="header">
						<i class="fa fa-map-pin"></i><strong>
{{$trans['general']['nav_zip_codes']}}</strong> <!-- <small>dropdown support</small> -->
			        </div>
			        <div>
						<b-row>
							<b-col lg="6">
								<b-col sm="12" class="p-0">
									<b-form-group :label="$trans[$route.meta.trans_key]['zip_code']" label-for="search-zip_code">
										<b-form-input v-on:keyup.13.native="do_search1" v-on:keypress.native="search1.value = mask_zip($event)" v-model="search1.value" :class="(search1.has_error) ? 'is-invalid' : ''" placeholder="xxxx-yyy" id="search-zip_code" maxlength="8" class="text-capitalize"></b-form-input>
									<small v-if="search1.has_error" class="text-danger">{{search1.error}}</small>
									</b-form-group>
								</b-col>

								<b-row>
									<b-col lg="6">
										<b-form-group :label="$trans[$route.meta.trans_key]['street_avenue']" label-for="search-street">
											<b-form-input v-on:keyup.13.native="do_search2" v-model="search2.value" :class="(search2.has_error) ? 'is-invalid' : ''" id="search-street" class="text-capitalize"></b-form-input>
											<small v-if="search2.has_error" class="text-danger">{{search2.error}}</small>
										</b-form-group>
									</b-col>
									<b-col lg="6">
										<b-form-group :label="$trans[$route.meta.trans_key]['local_county']" label-for="search-local_county">
											<b-form-input v-on:keyup.13.native="do_search2" v-model="search3.value" :class="(search3.has_error) ? 'is-invalid' : ''" id="search-local_county" class="text-capitalize"></b-form-input>
										<small v-if="search3.has_error" class="text-danger">{{search3.error}}</small>
										</b-form-group>
									</b-col>
								</b-row>
								<b-row>
									<b-col md="12">
										<b-tabs pills>
											<b-tab :title="items.length+ '/' +total_results+ ' ' +$trans[$route.meta.trans_key]['results']">
												<b-col md="12" class="card-loader-container p-0">
													<loader v-if="loading1"></loader>
													<div v-else>
														<div class="d-lg-none d-block">
															<b-list-group class="mobile-list">
	 															<b-list-group-item class="cursor-pointer" v-on:click.prevent="change_item(item)" v-for="(item, key) in items" :key="key">{{item.zip_code}}, {{item.descricao_arteria}}, {{item.nome_localidade}}, {{item.nome_concelho}}</b-list-group-item>
															</b-list-group>
														</div>
														<div class="list-group d-lg-block d-none">
															<div v-on:click.prevent="change_item(item)" v-for="(item, key) in items" :key="key">
																<b-btn v-b-toggle="'item_'+key" :class="(opened_item && item1_selected.id == item.id) ? 'active' : ''" :aria-controls="'item_'+key" :aria-expanded="(opened_item && item1_selected.id == item.id) ? 'true' : 'false'" class="white-space-normal list-group-item list-group-item-action">{{item.zip_code}}, {{item.descricao_arteria}}, {{item.nome_localidade}}, {{item.nome_concelho}}</b-btn>
		  														<b-collapse class="p-3" :id="'item_'+key" :visible="opened_item && item1_selected.id == item.id">
																	<div v-on:click.stop="">
		 																<p><b>{{$trans[$route.meta.trans_key]['district']}}: </b><router-link :to="base_url+ '/div-admin/distritos/' +item.id_district">{{item.nome_distrito}}</router-link></p>
																		<p><b>{{$trans[$route.meta.trans_key]['county']}}: </b><router-link :to="base_url+ '/div-admin/concelhos/' +item.id_county">{{item.nome_concelho}}</router-link></p>
																		<p><b>{{$trans[$route.meta.trans_key]['nome_localidade']}}:</b> {{item.nome_localidade}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['designacao_postal']}}:</b> {{item.designacao_postal}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['cod_localidade']}}:</b> {{item.cod_localidade}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['tipo_arteria']}}:</b> {{item.tipo_arteria}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['primeira_preposicao']}}:</b> {{item.primeira_preposicao}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['segunda_preposicao']}}:</b> {{item.segunda_preposicao}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['designacao_arteria']}}:</b> {{item.designacao_arteria}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['descricao_troco']}}:</b> {{item.descricao_troco}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['info_artéria']}}:</b> {{item.info_artéria}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['cod_arteria']}}:</b> {{item.cod_arteria}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['titulo_arteria']}}:</b> {{item.titulo_arteria}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['nome_cliente']}}:</b> {{item.nome_cliente}}</p>
																		<p><b>Latitude</b>: {{item.latitude}}</p>
																		<p><b>Longitude</b>: {{item.longitude}}</p>
		   															</div>
																</b-collapse>
															</div>
														</div>
													</div>
													<b-col sm="12" class="padding-t-15 text-center">
														<button v-if="load_more_btn" class="btn btn-info mt-3" v-on:click="load_more">Ver mais</button>
													</b-col>
												</b-col>
											</b-tab>
								        </b-tabs>
									</b-col>
								</b-row>
							</b-col>
							<b-col v-if="!is_mobile()" lg="6" class="d-lg-block d-none">
								<b-col md="12" class="p-0">
									<b-form-group label="hidden-inp" class="invisible d-lg-block d-none">
										<b-form-select>
											<option></option>
										</b-form-select>
									</b-form-group>
									<b-form-group :label="$trans[$route.meta.trans_key]['map_style']" label-for="sel-map-style">
										<b-form-select id="sel-map-style" v-model="map.style" text="Estilo do mapa" right>
											<option v-for="(item, idx) in map.styles" :key="idx" :value="item">{{item.name}}</option>
										</b-form-select>
									</b-form-group>
								</b-col>
								<b-row>
									<b-col md="12">
										<b-tabs pills class="text-capitalize">
											<b-tab :title="$trans[$route.meta.trans_key]['map']">
												<div class="loader-wrapper text-transform-none">
													<loader v-if="loading1"></loader>
													<h5 v-else-if="item1_selected === null" class="select_text align-center">{{$trans[$route.meta.trans_key]['select_result_box']}}</h5> 
							    					<l-map-wrapper v-else-if="maps_data1 != null && item1_selected !== null" v-bind:data="maps_data1" v-bind:mapStyle="map.style" v-on:setStyles="setMapStyles" v-bind:mapType="'markerCluster'" class="my-map-leaflet"></l-map-wrapper>
												</div>
											</b-tab>
										</b-tabs>
									</b-col>	
								</b-row>
							</b-col>
						</b-row>
			        </div>
			    </b-card>
			</b-col>
		</b-row>
		<div v-if="is_mobile()" class="d-lg-none d-block">
			<modal v-if="item1_selected !== null" v-on:close="item1_selected = null">
				<div slot="header"><h6>{{item1_selected.zip_code}}, {{item1_selected.descricao_arteria}}, {{item1_selected.nome_localidade}}</h6>
				</div> 
				<div slot="body">
					<div class="min-height-45">
						<b-form-select id="sel-map-style" v-model="map.style" text="Estilo do mapa" right>
							<option v-for="(item, idx) in map.styles" :key="idx" :value="item">{{item.name}}</option>
						</b-form-select>
					</div>
					<l-map-wrapper v-if="maps_data1 != null" v-bind:data="maps_data1" v-bind:mapStyle="map.style" v-on:setStyles="setMapStyles" v-bind:mapType="'markerCluster'" class="my-map-leaflet map-modal"></l-map-wrapper>
					<b-list-group class="mobile-list">
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['district']}}</b>: <router-link :to="base_url+ '/div-admin/distritos/' +item1_selected.id_district">{{item1_selected.nome_distrito}}</router-link></a></b-list-group-item>
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['county']}}</b>: <router-link :to="base_url+ '/div-admin/concelhos/' +item1_selected.id_county">{{item1_selected.nome_concelho}}</router-link></b-list-group-item>
						<b-list-group-item><b>Nome da localidade</b>: {{item1_selected.nome_localidade}}</b-list-group-item>
						<b-list-group-item><b>Designação postal</b>: {{item1_selected.designacao_postal}}</b-list-group-item>
						<b-list-group-item><b>Código da localidade</b>: {{item1_selected.cod_localidade}}</b-list-group-item>
						<b-list-group-item><b>Tipo da artéria</b>: {{item1_selected.tipo_arteria}}</b-list-group-item>
						<b-list-group-item><b>Primeira preposição</b>: {{item1_selected.primeira_preposicao}}</b-list-group-item>
						<b-list-group-item><b>Segunda preposição</b>: {{item1_selected.segunda_preposicao}}</b-list-group-item>
						<b-list-group-item><b>Designação da artéria</b>: {{item1_selected.designacao_arteria}}</b-list-group-item>
						<b-list-group-item><b>Descrição do troço</b>: {{item1_selected.descricao_troco}}</b-list-group-item>
						<b-list-group-item><b>Informação da artéria</b>: {{item1_selected.info_artéria}}</b-list-group-item>
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['cod_arteria']}}:</b> {{item1_selected.cod_arteria}}</b-list-group-item>
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['titulo_arteria']}}:</b> {{item1_selected.titulo_arteria}}</b-list-group-item>
						<b-list-group-item><b>Nome do cliente</b>: {{item1_selected.nome_cliente}}</b-list-group-item>
						<b-list-group-item><b>Latitude</b>: {{item1_selected.latitude}}</b-list-group-item>
						<b-list-group-item><b>Longitude</b>: {{item1_selected.longitude}}</b-list-group-item>
					</b-list-group>
				</div>
			</modal>
		</div>
	</div>
</template>

<script>
import LMapWrapper from '@/views/sub_components/LMapWrapper';
export default {
	name: 'ZipCode',
	components: {
		LMapWrapper
	},
	data() {
		return {
			items: [],
			loading1: true,
			item1_selected: null,
			search_param: this.$route.params.search_param,
			opened_item: false,
			maps_data1: null,
			search1: {
				value: '2765-350',
				has_error: false,
				error: this.$trans[this.$route.meta.trans_key]['zip_code_404']
			},
			search2: {
				value: '',
				has_error: false,
				error: 'Rua não encontrada'
			},
			search3: {
				value: '',
				has_error: false,
				error: 'Por favor preencha este campo'
			},
			req_offset: 0,
			last_req_url: '',
			load_more_btn: false,
			total_results: 0,
			map: {style: null, styles: []}
		}
	},
	methods: {
		get_items: function(url, input, find_or_fail, offset) {
			const that = this;
			that.get_req(url+ '/' +offset,
				function() { // before
					that.loading1 = true;
	            },
				function(response) { // success
					that.maps_data1 = response.body.data.map1;
					that.items = that.items.concat(response.body.data.items);
					if(that.req_offset === 0)
						that.total_results = response.body.data.total;
					that.load_more_btn = that.items.length < that.total_results;
					that.loading1 = false;
				},
				function(response) { // fail
					that.loading1 = false;
					input.has_error = true;
					that.load_more_btn = false;
					that.total_results = 0;
					if(response.status == 404 && find_or_fail) {
						that.abort_404();
					}
				},
				function(response) {
					that.last_req_url = url;
				}
			);
		},
		change_item: function(item) {
			if(this.item1_selected === item) {
				this.item1_selected = null;
				return;
			}
			this.item1_selected = item;
			this.maps_data1.map_data.markers = [item]
			this.maps_data1.map_data.longitude = item.longitude;
			this.maps_data1.map_data.latitude = item.latitude;
		},
		set_map_styles: function(styles) {
			this.map_styles_opts = styles;
		},
		do_search1: function() {
			this.reset_defaults();
			if(!this.is_zip_code(this.search1.value)) {
				this.search1.error = 'Formato incorreto, deve ser xxxx-yyy';
				this.search1.has_error = true;
				return;
			}
			this.items = [];
			this.search2.value = '';
			this.search3.value = '';
			this.get_items('zip-codes/' +this.search1.value, this.search1, false, 0);
		},
		do_search2: function() {
			this.reset_defaults();
			this.search1.value = '';
			if(this.search2.value.trim() == '' || this.search3.value.trim() == '') {
				if(this.search2.value.trim() == '') {
					this.search2.has_error = true;
					this.search2.error = 'Por favor preencha este campo';
				}
				if(this.search3.value.trim() == '') {
					this.search3.has_error = true;
					this.search3.error = 'Por favor preencha este campo';
				}
				return;
			}
			this.items = [];
			this.get_items('streets/' +this.search2.value+ '/' +this.search3.value, this.search2, false, 0);
		},
		load_more: function() {
			this.req_offset += 20;
			this.item1_selected = null;
			this.get_items(this.last_req_url, this.search2, false, this.req_offset);
		},
		is_zip_code: function(zip_code) {
			return /^\d{4}(-\d{3})?$/.test(zip_code);
		},
		reset_defaults: function() {
			this.opened_item = false;

			this.search1.has_error = false;
			this.search2.has_error = false;
			this.search3.has_error = false;
			
			this.search1.error = this.$trans[this.$route.meta.trans_key]['zip_code_404'];
			this.search2.error = 'Rua não encontrada';
			this.search3.error = 'Por favor preencha este campo';

			this.req_offset = 0;
		},
		mask_zip: function(event) {
            /*if (event.key && isNaN(event.key) && (this.search1.value.length !== 4 || event.key !== '-')) {
               event.preventDefault();
            } else if(this.search1.value.length === 4 && event.key !== '-') {
               return this.search1.value.substr(0, 4)+'-'+this.search1.value.substr(5);
            }*/
            return this.search1.value;
        },
		init_comp: function() {
			if(this.search_param != null && this.is_zip_code(this.search_param)) {
				this.search1.value = this.search_param;
				this.get_items('zip-codes/' +this.search1.value, this.search1, true, 0);
				return;	
			}
			if(this.search_param != null && !this.is_zip_code(this.search_param)) {
				this.search1.value = '';
				const search_param_spl =  this.search_param.split('|');
				if(search_param_spl.length < 2) {
					this.abort_404();
				}		
				this.search2.value = search_param_spl[0];
				this.search3.value = search_param_spl[1];
				this.get_items('streets/' +this.search2.value+ '/' +this.search3.value, this.search2, true, 0);

	            return;
	        }
			this.get_items('zip-codes/' +this.search1.value, this.search1, this.search1, true, 0);
		},
		setMapStyles: function(styles) {
			this.map.styles = styles;
			if(this.map.style === null)
				this.map.style = styles[3];
		},
	},
	computed: {
		
	},
	watch: {
		/*len_items: function(new_val, old_val) {
			if(new_val === 0)
				this.item1_selected = null;
		},*/
		item1_selected: function(new_val, old_val) {
			this.opened_item = new_val != null;
		},
		'$route.params.search_param': function(new_val, old_val) {
			if(typeof new_val === 'undefined') { //back button porpuses
				this.$router.go(-1);
			}
			else if(this.search_param != new_val) {
				this.search_param = new_val;
			}
			// this.items = [];
			// this.init_comp(false);
		},
		loading1: function(new_val, old_val) {
			if(!new_val) {
				let params = this.$route.params;
				if(this.search1.value.trim() != '') {
					params.search_param = this.search1.value;
				}
				else {
					params.search_param = this.search2.value+ '|' +this.search3.value;
				}
				this.$router.push({name: 'ZipCode', params: params});
				this.item1_selected = null;
			}
		}
	},
	created: function() {
		this.init_comp();
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.select_text {
		position: absolute;
		width: 100%;
	}
</style>
<style>
	
</style>